module.exports = __webpack_public_path__ + "static/img/15.3b501e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/15.png
// module id = 6lIq
// module chunks = 0